// Not every task has a deadline, so that key alone leaves the undated ones in an
// arbitrary order: the last activity settles them, newest first
const tasksSortingOrderFor = (key, desc) => (
  (key === 'tskEndDue')
    ? [{ key, desc }, { key: 'lastModified', desc: true }]
    : [{ key, desc }]
);

export default tasksSortingOrderFor;
